let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("7zMjZ"), load("a1dBM"), load("ahxSD"), load("7FkEF"), load("68Kzv"), load("3NvtU"), load("HDoKD")]).then(() => parcelRequire('forzB'));